<script>
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { CompletionTrackingGateMixin } from "%/dynamic-component-editor/standard-components/base-story-card/completion-tracking-gate-mixin";
import { useCompletionStatusStore, COMPLETION_STARTED }
  from "%/dynamic-component-editor/stores/completion-status-store";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "CompletionSetStarted",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.COMPLETION,
    displayName: "Set Started",
    displayIcon: "mdi:progress-clock",
    elementGroup: "storyElements",
  },
  extends: BaseButtonElement,
  mixins: [StoryPageElementMixin, CompletionTrackingGateMixin],
  computed: {
    shouldRenderButton() {
      return this.completionTrackingEnabled && !this.completionTwoStateMode;
    },
  },
  methods: {
    handleButtonClick() {
      if (this.editMode) {
        return;
      }
      const storyId = this.storyEntityId;
      if (!storyId) {
        return;
      }
      useCompletionStatusStore().setCompletionStatus(storyId, COMPLETION_STARTED, this.entity?.myFolder);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
